document.addEventListener('turbolinks:load', function() {
  const banner = document.querySelector('.js-floating-navbar-exp');
  const startScroll = 144;
  const togglePageHeaderTrialButton = () => {
    let currentScroll = window.scrollY || document.documentElement.scrollTop;

    if (currentScroll > startScroll) {
      banner.style.visibility = 'visible';
      banner.style.opacity = '1';
    } else {
      banner.style.opacity = '0';
      setTimeout(() => {
        if (window.scrollY <= startScroll) {
          banner.style.visibility = 'hidden';
        }
      }, 300);
    }
  };

  if (banner) {
    window.addEventListener('scroll', togglePageHeaderTrialButton);
  }
});
